"use client";
import * as React from "react";
const SvgStarOutlineRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m15.15 5.52-4.53-.38-1.76-4.08a.94.94 0 0 0-1.72 0L5.37 5.14l-4.51.38a.91.91 0 0 0-.54 1.6l3.43 2.92-1.02 4.33c-.19.78.68 1.4 1.39.98L8 13.06l3.88 2.3c.7.43 1.58-.2 1.4-.99l-1.04-4.33 3.43-2.92a.9.9 0 0 0-.52-1.6M8 11.35l-3.52 2.08.94-3.92-3.1-2.64 4.09-.35L8 2.82l1.6 3.71 4.1.35-3.11 2.64.93 3.92z" }));
export {
  SvgStarOutlineRound as default
};
